export default __webpack_public_path__ + "assets/people/default.4617a71924199d76e51a9f4cff83d584.svg";